import { render } from "./EmployeeApprovalsApproved.vue?vue&type=template&id=5ee6120b&scoped=true"
import script from "./EmployeeApprovalsApproved.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovalsApproved.vue?vue&type=script&lang=js"

import "./EmployeeApprovalsApproved.vue?vue&type=style&index=0&id=5ee6120b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee6120b"]])

export default __exports__